<!-- <app-topstrip></app-topstrip> -->
<mat-sidenav-container class="mainWrapper blue_theme light-theme" autosize autoFocus dir="ltr">
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->
  <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [opened]="!isOver"
    (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav customMobile">
    <div class="flex-layout">
      <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for(item of navItems; track item) {
          <app-nav-item [item]="item" (notify)="sidenav.toggle()">
          </app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>

      <p class="text-center version-style">Current Version {{appVersion}}</p>
    </div>
  </mat-sidenav>

  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class=" p-l-24 p-r-24" #content  [class.contentWrapper]="options.sidenavOpened">

    <main class="pageWrapper maxWidth">

      <!-- ============================================================== -->
      <!-- VerticalHeader -->
      <!-- ============================================================== -->
      <app-header [showToggle]="!isOver" (toggleMobileNav)="sidenav.toggle()"></app-header>
      

      <div class="m-t-30">
        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>
      </div>
    </main>

    <div class="p-16 p-t-8 p-b-30 text-center">
    &copy; Copyright <a class="text-decoration-none" 
        target="_blank">2025</a>
    </div>

  </mat-sidenav-content>

</mat-sidenav-container>